<script setup>
import "@/assets/css/mil-pricing.css";
const props = defineProps({
  dark: { type: Boolean, default: false }
});

const catChips = [
  { name: "SMARTPHONE", icon: "📱", color: "#60a5fa" },
  { name: "LAPTOP", icon: "💻", color: "#3b82f6" },
  { name: "TABLET", icon: "📟", color: "#10b981" },
  { name: "SMARTWATCH", icon: "⌚", color: "#6366f1" },
  { name: "HEADPHONES", icon: "🎧", color: "#94a3b8" },
];
</script>

<template>
  <div class="card" style="padding: 32px; margin: 0">
    <h3 style="margin: 0 0 20px; font-size: 20px; font-weight: 800; color: #1e293b; text-align: center">Data Compliance</h3>
    <div style="padding: 12px 20px; background: rgba(0, 103, 255, 0.05); border: 1px solid rgba(0, 103, 255, 0.1); border-radius: 10px; font-size: 13px; color: #475569; margin-bottom: 12px">
      Ensure your CSV includes the required columns for optimal results.
    </div>
    <div :style="{ background: dark ? '#00114B' : '#f1f5f9', padding: '12px 24px', borderRadius: '8px', color: dark ? 'white' : '#1e293b', fontFamily: 'monospace', fontSize: '15px', letterSpacing: '0.05em', fontWeight: 600, marginBottom: '24px' }">
      category, brand, grade, retail_price
    </div>
    <div style="display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 12px">
      <div style="display: flex; gap: 12px; flex-wrap: wrap">
        <div v-for="cat in catChips" :key="cat.name" style="display: flex; align-items: center; gap: 8px; padding: 8px 14px; background: white; border: 1px solid #e2e8f0; border-radius: 12px; font-size: 11px; font-weight: 700; color: #475569">
          <div :style="{ width: '24px', height: '24px', borderRadius: '50%', background: `${cat.color}15`, display: 'flex', alignItems: 'center', justifyContent: 'center', color: cat.color }">{{ cat.icon }}</div>
          {{ cat.name }}
        </div>
      </div>
      <div style="padding: 8px 16px; border-radius: 12px; border: 1.5px solid #0067ff; color: #0067ff; font-weight: 800; font-size: 11px">
        GRADES: A, B, C, D
      </div>
    </div>
  </div>
</template>
